import { FC, memo } from 'react';

import ConvenienceDispatchesPage from './ConvenienceDispatches/index';

const ConvenienceDispatches: FC = memo(() => (
  <ConvenienceDispatchesPage />
));

export default ConvenienceDispatches;
